export const toolBarStyle = {
  paddingLeft: "13px",
  paddingRight: "13px",
  height: "50px",
  backgroundColor: "#ffffff"
}
